import { useState, useEffect } from 'react';

/**
 * AnimatedCounter - Animates a number from 0 to target value
 * @param {number} end - Target number to count to
 * @param {number} duration - Animation duration in ms (default: 2000)
 * @param {string} suffix - Optional suffix to append (e.g., '%', '+')
 */
export default function AnimatedCounter({ end, duration = 2000, suffix = '' }) {
  const [count, setCount] = useState(0);
  
  useEffect(() => {
    let startTime;
    const animate = (currentTime) => {
      if (!startTime) startTime = currentTime;
      const progress = Math.min((currentTime - startTime) / duration, 1);
      setCount(Math.floor(progress * end));
      if (progress < 1) requestAnimationFrame(animate);
    };
    requestAnimationFrame(animate);
  }, [end, duration]);
  
  return <span>{count}{suffix}</span>;
}
